import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface InPersonMeetingState {
  selectedInPersonMeetingId: string;
  selectedInPersonMeetingData: any;
  startDateTime: string;
  endDateTime: string;
  meetingTitle: string;
  orgName: string;
  orgLogo: string;
}

const initialState: InPersonMeetingState = {
  selectedInPersonMeetingId: "",
  selectedInPersonMeetingData: null,
  startDateTime: "",
  endDateTime: "",
  meetingTitle: "",
  orgName: "",
  orgLogo: "",
};

export const inPersonMeetingSlice = createSlice({
  name: "inPersonMeeting",
  initialState,
  reducers: {
    setInPersonMeetingId: (
      state: InPersonMeetingState,
      action: PayloadAction<string>
    ) => {
      state.selectedInPersonMeetingId = action.payload;
    },
    setInPersonMeetingData: (
      state: InPersonMeetingState,
      action: PayloadAction<any>
    ) => {
      state.selectedInPersonMeetingData = action.payload;
      // Automatically extract common fields
      if (action.payload) {
        state.meetingTitle = action.payload.title || action.payload.meetingTitle || "";
        state.startDateTime = action.payload.start || action.payload.startDateTime || "";
        state.endDateTime = action.payload.end || action.payload.endDateTime || "";
      }
    },
    setInPersonStartDateTime: (
      state: InPersonMeetingState,
      action: PayloadAction<string>
    ) => {
      state.startDateTime = action.payload;
    },
    setInPersonEndDateTime: (
      state: InPersonMeetingState,
      action: PayloadAction<string>
    ) => {
      state.endDateTime = action.payload;
    },
    setInPersonMeetingTitle: (
      state: InPersonMeetingState,
      action: PayloadAction<string>
    ) => {
      state.meetingTitle = action.payload;
    },
    setInPersonOrgName: (
      state: InPersonMeetingState,
      action: PayloadAction<string>
    ) => {
      state.orgName = action.payload;
    },
    setInPersonOrgLogo: (
      state: InPersonMeetingState,
      action: PayloadAction<string>
    ) => {
      state.orgLogo = action.payload;
    },
    clearInPersonMeetingData: (state: InPersonMeetingState) => {
      state.selectedInPersonMeetingId = "";
      state.selectedInPersonMeetingData = null;
      state.startDateTime = "";
      state.endDateTime = "";
      state.meetingTitle = "";
      state.orgName = "";
      state.orgLogo = "";
    },
  },
});

export const {
  setInPersonMeetingId,
  setInPersonMeetingData,
  setInPersonStartDateTime,
  setInPersonEndDateTime,
  setInPersonMeetingTitle,
  setInPersonOrgName,
  setInPersonOrgLogo,
  clearInPersonMeetingData,
} = inPersonMeetingSlice.actions;

export default inPersonMeetingSlice.reducer;

